@if (showSpinner) {
<app-loader> </app-loader>
}
<main class="content-wrapper" [ngClass]="{ 'dark-backroun-main': selectedMode === 'dark' }">
  <div class="apply-form-main bg-light" [ngClass]="{ 'dark-backroun-main': selectedMode === 'dark' }">
    <!-- form start munib  -->
    <form id="form-link-outside-btn" name="empForm" #f="ngForm" (ngSubmit)="onSubmit(f)">
      <!--Start 1st Section Personal Information  -->
      <div class="create-form pt-2 pl-4 pr-4 border" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
        <div class="mb-4 lblTopMargin">
          <h5>Create New User</h5>
        </div>

        <div class="row">
          <div class="col-12 p-0">
            <div class="form-group user-new-image">
              <div class="fake-image">
                <img [src]="selectedImage ? selectedImage : '../../assets/theme1/profile-fake.png'"
                  alt="Selected Image" />
              </div>
              <div class="upload-image-button upfile">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.0026 1.33398V10.6673M1.33594 6.00065H10.6693" stroke="white" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <input type="file" name="profile_image" [ngModel]="apidata != null ? apidata.imagePath : null"
                  id="profile_image" accept="image/*" class="file btnPointer" (change)="onFileChange($event)"
                  #profile_image_input />
                <input type="hidden" name="user_image" [(ngModel)]="imagePath" id="userImage" />
              </div>
            </div>
            @if (profileImageInvalid) {
            <div class="warning-media mt-1 ml-2">
              Image Size exceeds limit (max 1025 KB).
            </div>
            }
          </div>
          <div class="col-md-6">
            <div class="form-group wrapper-attendance-userId">
              <label>Attendance ID*</label>
              <input type="number" inputmode="none" name="attendance_user_id" [(ngModel)]="attendance_user_id"
                id="user_id" placeholder="Write Here" class="form-control no-spin-arrows pl-4" ngModel
                #user_id="ngModel" required [disabled]="disable_user_excluded_attendance" />
              <input class="form-check-input skip-attendance-userId custom-checkbox" type="checkbox"
                id="disable_user_excluded_attendance" name="disable_user_excluded_attendance"
                title="Use this checkbox when creating profiles for CEOs, CTOs, or owners whose attendance is not required."
                [(ngModel)]="disable_user_excluded_attendance" (ngModelChange)="onToggleChange()" />
            </div>

            @if (user_id.touched && user_id.invalid) {
            <div class="warning">
              Attendance Id is required.
            </div>
            }
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Gender*</label>
              <select id="gender" [ngModel]="apidata != null ? apidata.gender : null" name="gender"
                data-toggle="dropdown" class="dropdown-toggle checks-dropdown form-control pl-4 selectpicker" ngModel
                #gender="ngModel" required>
                <option value="null" disabled selected hidden>Choose</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select>
              @if (gender.touched && gender.invalid) {
              <div class="warning">
                Select Gender
              </div>
              }
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>First Name*</label>
              <input type="text" name="first_name" [ngModel]="apidata != null ? apidata.first_name : null"
                id="first_name" placeholder="Write here*" class="form-control pl-4"
                (input)="restrictInputToAlphabets($event)" ngModel #first_name="ngModel" required />
              @if (first_name.touched && first_name.invalid) {
              <div class="warning">
                First Name is required.
              </div>
              }
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Last Name*</label>
              <input type="text" name="last_name" [ngModel]="apidata != null ? apidata.last_name : null" id="last_name"
                placeholder="Write here" class="form-control pl-4" (input)="restrictInputToAlphabets($event)" ngModel
                #last_name="ngModel" required />
              @if (last_name.touched && last_name.invalid) {
              <div class="warning">
                Last Name is required.
              </div>
              }
            </div>
          </div>

          @if (uuid === null || uuid === undefined) {
          <div class="col-12 d-flex flex-wrap p-0">
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label>Password*</label>
                <input type="text" name="password" id="password" placeholder="Write here" class="form-control pl-4"
                  (input)="restrictlastname($event)" ngModel #password="ngModel" />
                @if (password.touched && password.invalid) {
                <div class="warning">
                  Password required.
                </div>
                }
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label>Confirm password*</label>
                <input type="text" name="confirm_password" id="confirm_password" (input)="restrictlastname($event)"
                  placeholder="Write here" class="form-control pl-4" ngModel #confirm_password="ngModel" />
                @if (confirm_password.touched && confirm_password.invalid) {
                <div class="warning">
                  Please Confirm your Password.
                </div>
                }
                @if (
                confirm_password.touched &&
                password.value !== confirm_password.value
                ) {
                <div class="warning">
                  Passwords do not match.
                </div>
                }
              </div>
            </div>
          </div>
          }
          <div class="col-md-6">
            <div class="form-group">
              <label>Email*</label>
              <input type="email" name="email" [ngModel]="apidata != null ? apidata.email : null" id="email"
                placeholder="Write here" class="form-control pl-4" ngModel #email="ngModel" email required />
              @if (email.touched && !email.valid) {
              <div class="warning">
                Email is required.
              </div>
              }
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Phone Number*</label>
              <input type="number" name="phone_number" [ngModel]="apidata != null ? apidata.phone_number : null"
                id="phone_number" placeholder="Write here" class="form-control no-spin-arrows pl-4" ngModel
                #phone_number="ngModel" required />
              @if (phone_number.touched && phone_number.invalid) {
              <div class="warning">
                Phone No. required
              </div>
              }
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>CNIC*</label>
              <input type="text" name="cnic" [ngModel]="apidata != null ? apidata.cnic : null" id="cnic"
                placeholder="Write here" class="form-control pl-4" ngModel #cnic="ngModel"
                pattern="[0-9]{5}-[0-9]{7}-[0-9]{1}" required />
              @if (cnic.touched && cnic.invalid) {
              <div class="warning">
                i.e. 00000-0000000-0
              </div>
              }
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Date of birth*</label>
              <input type="text" [ngModel]="apidata != null ? apidata.dob : null" placeholder="Write here"
                onfocus="(this.type='date')" onblur="(this.type= this.value ? 'date' : 'text')" name="dob" id="dob"
                ngModel #dob="ngModel" class="form-control date-type pl-4" id="dob" required />
              @if (dob.touched && dob.invalid) {
              <div class="warning">
                Date of Birth required.
              </div>
              }
            </div>
          </div>

          <div class="main-user-role">
            <div class="form-group pl-3 pr-3 mb-0">
              <label>User Role*</label>
              <div class="row">
                @for (role of user_Roles; track role) {
                @if (role.is_active == 1) {
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="radio-button-label">
                      <input type="radio" [value]="role.id" [(ngModel)]="selectedRole" name="role" required />
                      {{ role.role_name }}
                    </label>
                    @if (!selectedRole && role.touched) {
                    <div class="warning">
                      Select a role
                    </div>
                    }
                  </div>
                </div>
                }
                }
              </div>
            </div>
          </div>




          <div class="col-12 col-md-12">
            <div class="form-group textareaCreateuser">
              <label>About*</label>
              <textarea class="form-control pl-4" [ngModel]="apidata != null ? apidata.description : null" id="about"
                rows="3" name="about" ngModel #about="ngModel" placeholder="Write here" required></textarea>
              @if (about.touched && about.invalid) {
              <div class="warning">
                About required.
              </div>
              }
            </div>
          </div>





          <!-- above -->
        </div>
      </div>
      <!--End 1st Section Personal Information -->
      <!--Start 2nd Section Address Information -->
      <div class="create-form pt-2 pl-4 pr-4 border" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
        <div class="mb-4 lblTopMargin">
          <h5>Address</h5>
        </div>
        <!-- Row-->
        <div class="row">
          <!-- Row Start -->

          <div class="col-md-6">
            <div class="form-group" style="position: relative;">
              <label>Address 1*</label>
              <input type="text" name="address1" [ngModel]="addressdata != null ? addressdata.address1 : null"
                id="address1" (input)="onAddress1Input()"  [(ngModel)]="address1Value" placeholder="Write here " class="form-control pl-4" ngModel #address1="ngModel"
                required />
                  <ul class="suggestions-list" *ngIf="filteredSuggestions?.length">
                <li  *ngFor="let data of filteredSuggestions" (click)="selectSuggestion(data)">
                  {{ data?.description }}
                </li>
              </ul>
              @if (address1.touched && address1.invalid) {
              <div class="warning">
                i.e House No.8, Street No.2, DHA, X-Block,
              </div>
              }
            </div>
          </div>
          


          <div class="col-md-6">
            <div class="form-group">
              <label>Address 2</label>
              <input type="text" name="address2" [ngModel]="addressdata != null ? addressdata.address2 : null"
                id="address2" [(ngModel)]="address2Value" placeholder="Write here" class="form-control pl-4" ngModel #address2="ngModel" required />
              @if (address2.touched && address2.invalid) {
              <div class="warning">
                i.e House No.8, Street No.2, DHA, X-Block,
              </div>
              }
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>City*</label>
              <input type="text" name="city" [ngModel]="addressdata != null ? addressdata.city : null" id="city"
                placeholder="Write here" [(ngModel)]="city2" class="form-control pl-4" ngModel #city="ngModel" required />
              @if (city.touched && city.invalid) {
              <div class="warning">
                i.e. Munich
              </div>
              }
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>State*</label>
              <input type="text" name="state" [ngModel]="addressdata != null ? addressdata.state : null" id="state"
                placeholder=" Write here" [(ngModel)]="state2" class="form-control pl-4" ngModel #state="ngModel" required />
              @if (state.touched && state.invalid) {
              <div class="warning">
                i.e. Baymen
              </div>
              }
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Postal Code*</label>
              <input type="number" name="postal_code" [ngModel]="addressdata != null ? addressdata.postal_code : null"
                id="postal_code" [(ngModel)]="postal_cide2" placeholder="Write here" class="form-control no-spin-arrows pl-4" ngModel
                #postal_code="ngModel" required />
              @if (postal_code.touched && postal_code.invalid) {
              <div class="warning">
                postal code required
              </div>
              }
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Country*</label>
              <select id="country" name="country" [ngModel]="addressdata != null ? addressdata.country : null"
                data-toggle="dropdown" [(ngModel)]="country2" class="dropdown-toggle checks-dropdown form-control pl-4 selectpicker" ngModel
                #country="ngModel" required>
                <option value="null" disabled selected hidden>Choose</option>
                @for (cnt of countryList; track $index) {
                <option [value]="cnt">
                  {{ cnt }}
                </option>
                }
              </select>
              @if (country.touched && country.invalid) {
              <div class="warning">
                Select Country
              </div>
              }
            </div>
          </div>

          <!-- Row End -->
        </div>
      </div>
      <!--end 2nd Section Address Information -->
      <!--Start 3rd Section Contacts -->
      <div class="create-form pt-2 pl-4 pr-4 border" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
        <div class="mb-4 lblTopMargin">
          <h5>Employment Details</h5>
        </div>
        <!-- Row-->
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Select Orgnization*</label>
              <select id="organization" [ngModel]="apidata != null ? apidata.organization_id : null"
                name="organizationid" data-toggle="dropdown"
                class="dropdown-toggle checks-dropdown form-control pl-4 selectpicker" ngModel #organization="ngModel"
                required>
                <option value="null" disabled selected hidden>
                  Choose
                </option>
                @for (org of organizations; track org) {
                <option [value]="org.id">
                  {{ org.name }}
                </option>
                }
              </select>

              @if (organization.touched && organization.invalid) {
              <div class="warning">
                Select Organization
              </div>
              }
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Select designation*</label>
              <select id="designation" [ngModel]="apidata != null ? apidata.designation_id : null" name="designation"
                data-toggle="dropdown" class="dropdown-toggle checks-dropdown form-control pl-4 selectpicker" ngModel
                #designation="ngModel" required>
                <option value="null" disabled selected hidden>
                  Choose
                </option>
                @for (desig of designations; track desig) {
                <option [value]="desig.id">
                  {{ desig.designation_name }}
                </option>
                }
              </select>
              @if (designation.touched && designation.invalid) {
              <div class="warning">
                Select Designation
              </div>
              }
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Select department*</label>
              <select id="department" [ngModel]="apidata != null ? apidata.department : null" name="department"
                class="form-control pl-4 selectpicker" ngModel #department="ngModel" required>
                <option value="null" disabled hidden>Choose</option>
                @for (dprt of departments; track dprt) {
                <option [value]="dprt">
                  {{ dprt }}
                </option>
                }
              </select>
              @if (department.touched && department.invalid) {
              <div class="warning">
                Select Departments
              </div>
              }
            </div>
          </div>


          <div class="col-md-6">
            <div class="form-group">
              <label>Sub-department*</label>
              <input type="text" name="sub_department" [ngModel]="apidata != null ? apidata.sub_department : null"
                id="sub_department" placeholder="Write here" class="form-control no-spin-arrows pl-4" ngModel
                #sub_department="ngModel" required />
              @if (sub_department.touched && sub_department.invalid) {
              <div class="warning">
                Enter Sub Department
              </div>
              }
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Job Type*</label>
              <select id="employee_type" [ngModel]="apidata != null ? apidata.employee_type : null" name="employee_type"
                class="dropdown-toggle checks-dropdown form-control pl-4 selectpicker" (change)="getLeaveCount($event)"
                #employee_type="ngModel" required>
                <option value="null" disabled selected hidden>
                  Choose
                </option>

                @for (emp_type of employeeType; track emp_type) {
                <option [value]="emp_type">
                  {{ emp_type }}
                </option>
                }
              </select>
              @if (employee_type.touched && employee_type.invalid) {
              <div class="warning">
                Select Job type.
              </div>
              }
            </div>
          </div>

          <!-- Hidden total leaves field -->
          <div class="form-group">
            <input type="hidden" class="form-control pl-4" name="assigned_leaves" [value]="total_leaves" readonly />
          </div>

          <!-- Show date field only if employee type is Permanent -->
          @if (hidenbutton) {
          <div class="col-md-6">
            <div class="form-group">
              <label>Permanent Date*</label>
              <input type="text" name="permanent_date" id="permanent_date" placeholder="Write here"
                class="form-control date-type pl-4" [(ngModel)]="permanentDate" (change)="onPermanentDateChange()"
                required onfocus="(this.type='date')" onblur="(this.type= this.value ? 'date' : 'text')" />
            </div>
          </div>
          }


          <div class="col-md-6">
            <div class="form-group">
              <label>Joining date*</label>
              <input type="text" name="joining_date" [ngModel]="apidata != null ? apidata.joining_date : null"
                id="joining_date" placeholder="mm/dd/yyyy" ngModel #joining_date="ngModel"
                class="form-control date-type pl-4" id="joining_date" required onfocus="(this.type='date')"
                onblur="(this.type= this.value ? 'date' : 'text')" />
              @if (joining_date.touched && joining_date.invalid) {
              <div class="warning">
                Select Date of Joining
              </div>
              }
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Job Position*</label>
              <select id="employee_role" [ngModel]="apidata != null ? apidata.employee_role_id : null"
                name="employee_role" data-toggle="dropdown"
                class="dropdown-toggle checks-dropdown form-control pl-4 selectpicker" ngModel #employee_role="ngModel"
                required>
                <option value="null" disabled selected hidden>
                  Choose
                </option>
                @for (role of office_roles_array; track role) {
                <option [value]="role.id">
                  {{ role.role_names }}
                </option>
                }
              </select>
              @if (employee_role.touched && employee_role.invalid) {
              <div class="warning">
                Select Employee Position
              </div>
              }
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Employee Status*</label>
              <select id="employee_status" [ngModel]="apidata != null ? apidata.employee_status : null"
                name="employee_status" data-toggle="dropdown"
                class="dropdown-toggle checks-dropdown form-control pl-4 selectpicker" ngModel
                #employee_status="ngModel" required>
                <option value="null" disabled selected hidden>
                  Choose
                </option>
                @for (sts of statuses; track sts) {
                <option [value]="sts">
                  {{ sts }}
                </option>
                }
              </select>
              @if (employee_status.touched && employee_status.invalid) {
              <div class="warning">
                Select Employee Status
              </div>
              }
            </div>
          </div>


          <!-- 2nd end -->
        </div>
      </div>
      <!--end 3rd Section Contacts -->


      <!-- Salary Section -->
      <div class="create-form pt-2 pl-4 pr-4 border" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
        <div class="mb-4 lblTopMargin">
          <h5>Salary Details</h5>
        </div>
        <!-- Row-->
        <div class="main-inner-section">
          <div class="row">
            <div class="col-12 mb-3">
              <div class="salary-radio-main">
                <div class="monthly_check">
                  <input type="radio" id="monthly" name="salary_type" value="monthly" [(ngModel)]="salaryType">
                  <label class="mb-0" for="monthly">Monthly</label>
                </div>
                <div class="monthly_check">
                  <input type="radio" id="hourly" name="salary_type" value="hourly" [(ngModel)]="salaryType">
                  <label class="mb-0" for="hourly">Hourly</label>
                </div>
              </div>

            </div>
            @if (salaryType === 'monthly') {
            <div class="col-md-6">
              <div class="form-group salary-fields">
                <label>Monthly Salary*</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Rs/-</span>
                  </div>
                  <input type="text" name="salary" [ngModel]="apidata.basic_salary" id="salary" placeholder="Write here"
                    class="form-control pl-4" ngModel #salary="ngModel" (input)="restrictInputToAccounts($event)"
                    required />
                </div>
                <!-- @if (salary.touched && salary.invalid) {
                <div class="warning">
                  Enter Salary.
                </div>
                } -->
              </div>
            </div>
            }

            @if (salaryType === 'monthly') {
            <div class="col-md-6">
              <div class="form-group salary-fields">
                <label>Salary Tax*</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Rs/-</span>
                  </div>
                  <input type="number" name="tax" [ngModel]="apidata != null ? apidata.monthly_tax_amount : null"
                    id="tax" placeholder="Monthly Salary Tax*" class="form-control pl-4" ngModel #tax="ngModel"
                    required />
                </div>
                <!-- @if (tax.touched && tax.invalid) {
                <div class="warning">
                  Enter Employee Monthy Salary Tax
                </div>
                } -->
              </div>
            </div>
            }

            @if (salaryType === 'hourly') {
            <div class="col-md-6">
              <div class="form-group salary-fields">
                <label>Hourly Rate*</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Rs/-</span>
                  </div>
                  <input type="text" name="salary" [ngModel]="apidata != null ? apidata.basic_salary : null" id="salary"
                    placeholder="Write here" class="form-control pl-4" ngModel #salary="ngModel"
                    (input)="restrictInputToAccounts($event)" required />
                </div>
                <!-- @if (salary.touched && salary.invalid) {
                <div class="warning">
                  Enter Salary.
                </div>
                } -->
              </div>
            </div>
            }
            <div class="col-md-12 open_salary_field">
              <div class="form-group">
                <div class="radio-buttons ml-2">
                  <input type="checkbox" name="open_salary"
                    [ngModel]="apidata != null ? apidata.open_salary == 1 : false" />
                  <label class="mb-0 radio-button-label" [ngClass]="{ radio2: selectedMode === 'dark' }">Is Salary
                    Open?</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group salary-fields">
            <label>Bank account*</label>
            <div class="input-group">
              <div class="input-group-prepend input-group-img">
                <span class="input-group-text">
                  <img src="../../../assets/theme1/mezan-bank.png" alt="icon missing" />
                </span>
              </div>
              <input type="text" name="ac_number" [ngModel]="apidata != null ? apidata.ac_number : null" id="ac_number"
                placeholder="Bank Account#*" class="form-control no-spin-arrows pl-4" ngModel #ac_number="ngModel"
                required />
            </div>

            <!-- @if (ac_number.touched && ac_number.invalid) {
            <div class="warning">
              i.e. 0000-0000000000 also can add IBAN No.
            </div>
            } -->
          </div>
        </div>
      </div>



      <!-- cards selection section -->
      <!-- <div class="create-form pt-2 pl-4 pr-4 border" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                                                          <div class="mb-4 d-flex justify-content-between device-head lblTopMargin">
                                                            <h5>Cards Selection</h5>
                                                          </div>
                                                          <div class="row" *ngIf="cards?.length">
                                                            <ng-container *ngFor="let cardGroup of cards; let cardIndex = index">
                                                              <div *ngFor="let card of cardGroup; let innerIndex = index" class="col-2 pb-3 card-images"
                                                                (click)="selectCard(card.card_name)">
                                                                <img [src]="card.card_image" alt="{{ card.card_name }}" />
                                                                <div class="circle" *ngIf="selectedCardName === card.card_name"></div>
                                                              </div>
                                                            </ng-container>
                                                          </div>

                                                          <div *ngIf="!cards?.length">
                                                            <p>No cards available.</p>
                                                          </div>
                                                        </div> -->

      <!-- end cards selection section -->

      <!-- device section -->
      <!-- <div class="create-form pt-2 pl-4 pr-4 border" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                                                        <div class="mb-4 d-flex justify-content-between device-head lblTopMargin">
                                                          <h5>Devices Info</h5>
                                                          <h5><i class="fa fa-plus-circle" (click)="addNewDevice()"></i></h5>
                                                        </div>

                                                        <div class="main-inner-section">
                                                          <div class="row">
                                                            <div class="col-md-12">
                                                              <div class="form-group">
                                                                <table class="col-12 device-table" [ngClass]="{ 'dark-backround-table': selectedMode === 'dark' }">
                                                                  <tr class="device-table-heading1">
                                                                    <th>Device Name</th>
                                                                    <th>Device ID</th>
                                                                    <th class="action">Action</th>
                                                                  </tr>
                                                                  <tr class="device-data" *ngFor="let device of device_id; let i = index">
                                                                    <td>
                                                                      <span *ngIf="!device.isEditing">{{
                                                                        device.device_name
                                                                      }}</span>
                                                                      <input name="device_name" *ngIf="device.isEditing" [(ngModel)]="device.device_name" />
                                                                    </td>
                                                                    <td>
                                                                      <span *ngIf="!device.isEditing">{{
                                                                        device.device_id
                                                                      }}</span>
                                                                      <input name="device_id" *ngIf="device.isEditing" [(ngModel)]="device.device_id" />
                                                                    </td>
                                                                    <td class="action">
                                                                      <i class="fa" [ngClass]="device.isEditing ? 'fa-save' : 'fa-edit'"
                                                                      (click)="editOrSaveDevice(device)"></i>
                                                                      <i class="fa fa-trash-o" (click)="deleteDevice(i)"></i>
                                                                    </td>
                                                                  </tr>
                                                                </table>
                                                              </div>
                                                            </div>
                                                          </div>

                                                        </div>

                                                      </div> -->
      <!-- end device section -->

      <div class="create-form pt-2 pl-4 pr-4 border" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
        <div class="mb-4 d-flex justify-content-between device-head lblTopMargin">
          <h5>Devices Info</h5>

        </div>
        <!-- FORM (shows always if showForm=true) -->
        @if (showForm) {
        <div class="main-inner-section">
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label>Device Name*</label>
                <input type="text" name="device_name" id="device_name" class="form-control no-spin-arrows pl-4"
                  [(ngModel)]="newDevice.device_name" placeholder="Write Here" #device_name="ngModel"
                  [required]="!devices || devices.length === 0" />
                @if (device_name.touched && device_name.invalid) {
                <div class="warning">
                  Add Device Name
                </div>
                }
              </div>
            </div>
            <div class="col-6">
              <!-- Device ID -->
              <div class="form-group">
                <label>Device ID*</label>
                <input type="text" name="device_id" id="device_id" class="form-control no-spin-arrows pl-4"
                  [(ngModel)]="newDevice.device_id" placeholder="Write Here" #device_id="ngModel"
                  [required]="!devices || devices.length === 0" />
                @if (device_id.touched && device_id.invalid) {
                <div class="warning">
                  Add Device ID
                </div>
                }
              </div>
            </div>
            <div class="col-12 pb-4">
              <div class="device-action-buttons">
                <div class="btn action-common cancel-device" (click)="cancel()">Cancel</div>
                <div class="btn action-common add-device" (click)="saveDevice()">Save</div>
              </div>
            </div>
          </div>
        </div>
        }

        <!-- TABLE (always visible if there’s data) -->
        @if (devices && devices.length > 0) {
        <div class="row">
          <div class="col-12">
            <div class="add-device-button-section">
              <div class="add-device-button" (click)="addNewDevice()">
                <img src="../../../assets/theme1/circle-plus.png" alt="missing icon" />
                Add New Device
              </div>
            </div>
          </div>
          <div class="col-12">
          <div class="device-table">
  <table class="table">
    <thead>
      <tr>
        <th>Device Name</th>
        <th>Device ID</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let device of devices; let i = index">
        <td>{{ device.device_name }}</td>
        <td>{{ device.device_id }}</td>
        <td class="device-action-drop">
          <div class="custom-dropdown" [class.show]="dropdownOpenIndex === i">
            <!-- Dropdown toggle button -->
            <button type="button" class="btn btn-link p-0" (click)="toggleDropdown(i)">
              <svg width="5" height="18" viewBox="0 0 5 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.14771 10C2.66076 10 3.07667 9.55228 3.07667 9C3.07667 8.44772 2.66076 8 2.14771 8C1.63466 8 1.21875 8.44772 1.21875 9C1.21875 9.55228 1.63466 10 2.14771 10Z" stroke="#2D2D2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M2.14771 3C2.66076 3 3.07667 2.55228 3.07667 2C3.07667 1.44772 2.66076 1 2.14771 1C1.63466 1 1.21875 1.44772 1.21875 2C1.21875 2.55228 1.63466 3 2.14771 3Z" stroke="#2D2D2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M2.14771 17C2.66076 17 3.07667 16.5523 3.07667 16C3.07667 15.4477 2.66076 15 2.14771 15C1.63466 15 1.21875 15.4477 1.21875 16C1.21875 16.5523 1.63466 17 2.14771 17Z" stroke="#2D2D2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>

            <!-- Dropdown menu -->
            <ul class="dropdown-menu">
              <li><button class="dropdown-item text-danger" (click)="deleteDevice(i)">Delete</button></li>
            </ul>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
          </div>
        </div>
        }

      </div>




      <!--Start 4th Section Salary & Accounts Details shift-main-head-->
      @if (shouldShowExcludedAttendance()) {
      <div class="create-form pt-2 pb-4 pl-4 pr-4 border" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
        <div class="mb-4 d-flex justify-content-between device-head lblTopMargin">
          <h5>Shift Details</h5>
          <!-- <button type="button" class="btn btn-primary" >Copy All</button> -->
          <button type="button" class="btn copy-all" (click)="copyRow('mon')">
            Copy All
          </button>
        </div>
        <!-- Row Start -->
        <!-- new section  -->
        <div class="sift-time-table">
          <table class="table-bordered" [ngClass]="{ 'dark-backround-table': selectedMode === 'dark' }">
            <tr class="first-shift-tr">
              <th>Days</th>
              <th>Shift Start</th>
              <th>Shift End</th>
              <th>Working Hrs</th>
              <th>WFH</th>
              <th>Off Day</th>
            </tr>
            <tr>
              <th>{{ daysWeek[0] }}</th>
              <td>
                <div class="form-group mb-0">
                  <input type="time" name="mon_shift_start_time" id="mon_shift_start_time"
                    class="form-control no-spin-arrows" [(ngModel)]="dayData.mon.startTime"
                    [disabled]="offDayStatus['mon']" required (ngModelChange)="calculateWorkingHours('mon')" />
                </div>
              </td>
              <td>
                <div class="form-group mb-0">
                  <input type="time" name="mon_shift_end_time" id="mon_shift_end_time"
                    class="form-control no-spin-arrows" [(ngModel)]="dayData.mon.endTime"
                    [disabled]="offDayStatus['mon']" required (ngModelChange)="calculateWorkingHours('mon')" />
                </div>
              </td>
              <td>
                <div class="form-group mb-0">
                  <input type="number" name="mon_total_working_hours" id="mon_total_working_hours"
                    class="form-control no-spin-arrows" [(ngModel)]="dayData.mon.totalWorkingHours"
                    [disabled]="offDayStatus['mon']" required />
                </div>
              </td>
              <td>
                <div class="form-group m-0">
                  <div class="custom-control custom-switch toogle-wfh">
                    <input type="checkbox" class="custom-control-input" id="toggleButtonMon"
                      [checked]="toggleValues['mon']" (change)="toggleWHF('mon', $event)"
                      [disabled]="offDayStatus['mon']" />
                    <label class="custom-control-label" for="toggleButtonMon">{{
                      toggleValues["mon"] ? "Yes" : "No"
                      }}</label>
                  </div>
                </div>
              </td>
              <td>
                <div class="form-group m-0">
                  <div class="custom-control custom-switch toogle-wfh">
                    <input type="checkbox" class="custom-control-input" id="toggleBtnOffDayMon"
                      [checked]="offDayStatus['mon']" (click)="offDay('mon')" />
                    <label class="custom-control-label" for="toggleBtnOffDayMon">{{ offDayStatus["mon"] ? "Yes" : "No"
                      }}</label>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>{{ daysWeek[1] }}</th>
              <td>
                <div class="form-group mb-0">
                  <input type="time" name="tue_shift_start_time" id="tue_shift_start_time"
                    class="form-control no-spin-arrows" [(ngModel)]="dayData.tue.startTime"
                    [disabled]="offDayStatus['tue']" required (ngModelChange)="calculateWorkingHours('tue')" />
                </div>
              </td>
              <td>
                <div class="form-group mb-0">
                  <input type="time" name="tue_shift_end_time" id="tue_shift_end_time"
                    class="form-control no-spin-arrows" [(ngModel)]="dayData.tue.endTime"
                    [disabled]="offDayStatus['tue']" required (ngModelChange)="calculateWorkingHours('tue')" />
                </div>
              </td>
              <td>
                <div class="form-group mb-0">
                  <input type="number" name="tue_total_working_hours" id="tue_total_working_hours"
                    class="form-control no-spin-arrows" [(ngModel)]="dayData.tue.totalWorkingHours"
                    [disabled]="offDayStatus['tue']" required />
                </div>
              </td>
              <td>
                <div class="form-group m-0">
                  <div class="custom-control custom-switch toogle-wfh">
                    <input type="checkbox" class="custom-control-input" id="toggleButtonTue"
                      [checked]="toggleValues['tue']" (change)="toggleWHF('tue', $event)"
                      [disabled]="offDayStatus['tue']" />
                    <label class="custom-control-label" for="toggleButtonTue">{{
                      toggleValues["tue"] ? "Yes" : "No"
                      }}</label>
                  </div>
                </div>
              </td>
              <td>
                <div class="form-group m-0">
                  <div class="custom-control custom-switch toogle-wfh">
                    <input type="checkbox" class="custom-control-input" id="toggleBtnOffDayTue"
                      [checked]="offDayStatus['tue']" (click)="offDay('tue')" />
                    <label class="custom-control-label" for="toggleBtnOffDayTue">{{ offDayStatus["tue"] ? "Yes" : "No"
                      }}</label>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>{{ daysWeek[2] }}</th>
              <td>
                <div class="form-group mb-0">
                  <input type="time" name="wed_shift_start_time" id="wed_shift_start_time"
                    class="form-control no-spin-arrows" [(ngModel)]="dayData.wed.startTime"
                    [disabled]="offDayStatus['wed']" required (ngModelChange)="calculateWorkingHours('wed')" />
                </div>
              </td>
              <td>
                <div class="form-group mb-0">
                  <input type="time" name="wed_shift_end_time" id="wed_shift_end_time"
                    class="form-control no-spin-arrows" [(ngModel)]="dayData.wed.endTime"
                    [disabled]="offDayStatus['wed']" required (ngModelChange)="calculateWorkingHours('wed')" />
                </div>
              </td>
              <td>
                <div class="form-group mb-0">
                  <input type="number" name="wed_total_working_hours" id="wed_total_working_hours"
                    class="form-control no-spin-arrows" [(ngModel)]="dayData.wed.totalWorkingHours"
                    [disabled]="offDayStatus['wed']" required />
                </div>
              </td>
              <td>
                <div class="form-group m-0">
                  <div class="custom-control custom-switch toogle-wfh">
                    <input type="checkbox" class="custom-control-input" id="toggleButtonWed"
                      [checked]="toggleValues['wed']" (change)="toggleWHF('wed', $event)"
                      [disabled]="offDayStatus['wed']" />
                    <label class="custom-control-label" for="toggleButtonWed">{{
                      toggleValues["wed"] ? "Yes" : "No"
                      }}</label>
                  </div>
                </div>
              </td>
              <td>
                <div class="form-group m-0">
                  <div class="custom-control custom-switch toogle-wfh">
                    <input type="checkbox" class="custom-control-input" id="toggleBtnOffDayWed"
                      [checked]="offDayStatus['wed']" (click)="offDay('wed')" />
                    <label class="custom-control-label" for="toggleBtnOffDayWed">{{ offDayStatus["wed"] ? "Yes" : "No"
                      }}</label>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>{{ daysWeek[3] }}</th>
              <td>
                <div class="form-group mb-0">
                  <input type="time" name="thu_shift_start_time" id="thu_shift_start_time"
                    class="form-control no-spin-arrows" [(ngModel)]="dayData.thu.startTime"
                    [disabled]="offDayStatus['thu']" required (ngModelChange)="calculateWorkingHours('thu')" />
                </div>
              </td>
              <td>
                <div class="form-group mb-0">
                  <input type="time" name="thu_shift_end_time" id="thu_shift_end_time"
                    class="form-control no-spin-arrows" [(ngModel)]="dayData.thu.endTime"
                    [disabled]="offDayStatus['thu']" required (ngModelChange)="calculateWorkingHours('thu')" />
                </div>
              </td>
              <td>
                <div class="form-group mb-0">
                  <input type="number" name="thu_total_working_hours" id="thu_total_working_hours"
                    class="form-control no-spin-arrows" [(ngModel)]="dayData.thu.totalWorkingHours"
                    [disabled]="offDayStatus['thu']" required />
                </div>
              </td>
              <td>
                <div class="form-group m-0">
                  <div class="custom-control custom-switch toogle-wfh">
                    <input type="checkbox" class="custom-control-input" id="toggleButtonThu"
                      [checked]="toggleValues['thu']" (change)="toggleWHF('thu', $event)"
                      [disabled]="offDayStatus['thu']" />
                    <label class="custom-control-label" for="toggleButtonThu">{{
                      toggleValues["thu"] ? "Yes" : "No"
                      }}</label>
                  </div>
                </div>
              </td>
              <td>
                <div class="form-group m-0">
                  <div class="custom-control custom-switch toogle-wfh">
                    <input type="checkbox" class="custom-control-input" id="toggleBtnOffDayThu"
                      [checked]="offDayStatus['thu']" (click)="offDay('thu')" />
                    <label class="custom-control-label" for="toggleBtnOffDayThu">{{ offDayStatus["thu"] ? "Yes" : "No"
                      }}</label>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>{{ daysWeek[4] }}</th>
              <td>
                <div class="form-group mb-0">
                  <input type="time" name="fri_shift_start_time" id="fri_shift_start_time"
                    class="form-control no-spin-arrows" [(ngModel)]="dayData.fri.startTime"
                    [disabled]="offDayStatus['fri']" required (ngModelChange)="calculateWorkingHours('fri')" />
                </div>
              </td>
              <td>
                <div class="form-group mb-0">
                  <input type="time" name="fri_shift_end_time" id="fri_shift_end_time"
                    class="form-control no-spin-arrows" [(ngModel)]="dayData.fri.endTime"
                    [disabled]="offDayStatus['fri']" required (ngModelChange)="calculateWorkingHours('fri')" />
                </div>
              </td>
              <td>
                <div class="form-group mb-0">
                  <input type="number" name="fri_total_working_hours" id="fri_total_working_hours"
                    class="form-control no-spin-arrows" [(ngModel)]="dayData.fri.totalWorkingHours"
                    [disabled]="offDayStatus['fri']" required />
                </div>
              </td>
              <td>
                <div class="form-group m-0">
                  <div class="custom-control custom-switch toogle-wfh">
                    <input type="checkbox" class="custom-control-input" id="toggleButtonFri"
                      [checked]="toggleValues['fri']" (change)="toggleWHF('fri', $event)"
                      [disabled]="offDayStatus['fri']" />
                    <label class="custom-control-label" for="toggleButtonFri">{{
                      toggleValues["fri"] ? "Yes" : "No"
                      }}</label>
                  </div>
                </div>
              </td>
              <td>
                <div class="form-group m-0">
                  <div class="custom-control custom-switch toogle-wfh">
                    <input type="checkbox" class="custom-control-input" id="toggleBtnOffDayFri"
                      [checked]="offDayStatus['fri']" (click)="offDay('fri')" />
                    <label class="custom-control-label" for="toggleBtnOffDayFri">{{ offDayStatus["fri"] ? "Yes" : "No"
                      }}</label>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>{{ daysWeek[5] }}</th>
              <td>
                <div class="form-group mb-0">
                  <input type="time" name="sat_shift_start_time" id="sat_shift_start_time"
                    class="form-control no-spin-arrows" [(ngModel)]="dayData.sat.startTime"
                    [disabled]="offDayStatus['sat']" required (ngModelChange)="calculateWorkingHours('sat')" />
                </div>
              </td>
              <td>
                <div class="form-group mb-0">
                  <input type="time" name="sat_shift_end_time" id="sat_shift_end_time"
                    class="form-control no-spin-arrows" [(ngModel)]="dayData.sat.endTime"
                    [disabled]="offDayStatus['sat']" required (ngModelChange)="calculateWorkingHours('sat')" />
                </div>
              </td>
              <td>
                <div class="form-group mb-0">
                  <input type="number" name="sat_total_working_hours" id="sat_total_working_hours"
                    class="form-control no-spin-arrows" [(ngModel)]="dayData.sat.totalWorkingHours"
                    [disabled]="offDayStatus['sat']" required />
                </div>
              </td>
              <td>
                <div class="form-group m-0">
                  <div class="custom-control custom-switch toogle-wfh">
                    <input type="checkbox" class="custom-control-input" id="toggleButtonSat"
                      [checked]="toggleValues['sat']" (change)="toggleWHF('sat', $event)"
                      [disabled]="offDayStatus['sat']" />
                    <label class="custom-control-label" for="toggleButtonSat">{{
                      toggleValues["sat"] ? "Yes" : "No"
                      }}</label>
                  </div>
                </div>
              </td>
              <td>
                <div class="form-group m-0">
                  <div class="custom-control custom-switch toogle-wfh">
                    <input type="checkbox" class="custom-control-input" id="toggleBtnOffDaySat"
                      [checked]="offDayStatus['sat']" (click)="offDay('sat')" />
                    <label class="custom-control-label" for="toggleBtnOffDaySat">{{ offDayStatus["sat"] ? "Yes" : "No"
                      }}</label>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>{{ daysWeek[6] }}</th>
              <td>
                <div class="form-group mb-0">
                  <input type="time" name="sun_shift_start_time" id="sun_shift_start_time"
                    class="form-control no-spin-arrows" [(ngModel)]="dayData.sun.startTime"
                    [disabled]="offDayStatus['sun']" required (ngModelChange)="calculateWorkingHours('sun')" />
                </div>
              </td>
              <td>
                <div class="form-group mb-0">
                  <input type="time" name="sun_shift_end_time" id="sun_shift_end_time"
                    class="form-control no-spin-arrows" [(ngModel)]="dayData.sun.endTime"
                    [disabled]="offDayStatus['sun']" required (ngModelChange)="calculateWorkingHours('sun')" />
                </div>
              </td>
              <td>
                <div class="form-group mb-0">
                  <input type="number" name="sun_total_working_hours" id="sun_total_working_hours"
                    class="form-control no-spin-arrows" [(ngModel)]="dayData.sun.totalWorkingHours"
                    [disabled]="offDayStatus['sun']" required />
                </div>
              </td>
              <td>
                <div class="form-group m-0">
                  <div class="custom-control custom-switch toogle-wfh">
                    <input type="checkbox" class="custom-control-input" id="toggleButtonSun"
                      [checked]="toggleValues['sun']" (change)="toggleWHF('sun', $event)"
                      [disabled]="offDayStatus['sun']" />
                    <label class="custom-control-label" for="toggleButtonSun">{{
                      toggleValues["sun"] ? "Yes" : "No"
                      }}</label>
                  </div>
                </div>
              </td>
              <td>
                <div class="form-group m-0">
                  <div class="custom-control custom-switch toogle-wfh">
                    <input type="checkbox" class="custom-control-input" id="toggleBtnOffDaySun"
                      [checked]="offDayStatus['sun']" (click)="offDay('sun')" />
                    <label class="custom-control-label" for="toggleBtnOffDaySun">{{ offDayStatus["sun"] ? "Yes" : "No"
                      }}</label>
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div class="col-md-12 p-0 mt-3">
          <div class="col-md-6 pl-0">
            <div class="form-group">
              <label>Allow Multiple Punch</label>
              <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" id="toggleButtonMulPunch"
                  [checked]="toggleValueMultiplePunch" (change)="toggleChangedMP($event)" />
                <label class="custom-control-label" for="toggleButtonMulPunch">{{ toggleValueMultiplePunch ? "Yes" :
                  "No" }}</label>
              </div>
            </div>
          </div>
          <div class="col-md-12 m-0 flex-wrap p-0">
            <div class="form-group mb-3 check-box-form">
              <input class="checkox-field" type="checkbox" [ngModel]="apidata != null ? apidata.attandance_type : null"
                name="is_portal_checkin" id="is_portal_checkin" value="is_portal_checkin" [(ngModel)]="showDiv" />
              <label class="ml-2 mb-0">Portal Check-IN </label>
            </div>
            @if (showDiv) {
            <div class="col-12 hidden-radio-btn pl-2 d-flex justify-content-between">
              <div class="p-0">
                <input type="radio" id="Normal" name="portalCheckInRadioGroup" value="Normal"
                  [ngModel]="apidata != null ? apidata.attandance_type : null" />
                <label class="pl-1 pb-0">Normal</label>
              </div>
              <div class="p-0">
                <input type="radio" id="Open" name="portalCheckInRadioGroup" value="Open"
                  [ngModel]="apidata != null ? apidata.attandance_type : null" />
                <label class="pl-1 pb-0">Open</label>
              </div>
              <div class="p-0">
                <input type="radio" id="BD_Open" name="portalCheckInRadioGroup" value="BD_Open"
                  [ngModel]="apidata != null ? apidata.attandance_type : null" />
                <label class="pl-1 pb-0 mb-0">BD_Open</label>
              </div>
            </div>
            }
          </div>
        </div>
      </div>
      }
      <!--end 4th Section Salary & Accounts Details -->

      <!--Start 5th Section Employee Other Details -->
      <!--end 5th Section Employee Other Details -->
    </form>
    <!--form munib end -->
  </div>
</main>

<!-- button footers start -->
<div class="footer-button" [ngClass]="{ 'dark-backroun-main': selectedMode === 'dark' }">
  <div class="btn-float-right">
    <button type="" (click)="backward()" class="btn btn-light">Cancel</button>

    <button type="submit" class="btn btn-primary btnPointer ml-2" form="form-link-outside-btn">
      {{ uuid ? "Update" : "Create" }}
    </button>
  </div>
</div>
<!-- button footers end -->